import { useEffect, type ReactNode } from 'react';
import { useSetAtom } from 'jotai';
import { headerActionsAtom } from '../store';

/** Puts page-specific buttons in the shell header while mounted. */
export function useHeaderActions(node: ReactNode, deps: unknown[]) {
  const setActions = useSetAtom(headerActionsAtom);
  useEffect(() => {
    setActions(node);
    return () => setActions(null);
    // The caller lists what the node depends on.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setActions, ...deps]);
}
